import languagesConfig from "../../../../../../../wwwroot/json/languages.json";
import { filterLanguages, ILanguageMap, Language } from "@gtmhub/localization";
import { Component, OnInit } from "@angular/core";
import { AccountResolverService } from "@gtmhub/state/accountResolverService";
import { IAccount } from "@gtmhub/core";
import { AccountService } from "@gtmhub/accounts/accounts-service";
import { LanguagesConfigService } from "@gtmhub/localization/services/languages-config.service";

@Component({
  selector: "language",
  templateUrl: "./language.component.html",
  styleUrls: ["./language.component.less"],
})
export class LanguageComponent implements OnInit {
  public currentLanguage: Language;
  public supportedLanguages: ILanguageMap;
  public account: IAccount;

  constructor(private accountResolverService: AccountResolverService, private accountService: AccountService, private languagesConfigService: LanguagesConfigService) {}

  public ngOnInit(): void {
    this.account = this.accountResolverService.getAccountData();
    this.currentLanguage = this.account.language;

    this.languagesConfigService
      .getLanguageMap()
      .then((languageMap) => (this.supportedLanguages = languageMap))
      .catch(() => (this.supportedLanguages = filterLanguages("italian", languagesConfig.languageMap)));
  }

  // Replace service with a facade and use observable instead of promise once available
  public async setLanguage(language: Language): Promise<void> {
    const updatedAccount = { ...this.account, language };
    await this.accountService.updateAccount(this.account.id, { language });
    this.account = updatedAccount;
    this.accountResolverService.setAccountData(updatedAccount);
  }
}
